import clsx from 'clsx'
import * as serviceProviders from 'lib/settings/service-providers'
import { CSSProperties } from 'react'
import { ImageStandAlone as Image } from '../Image/Image'

export type providerIDs = keyof typeof serviceProviders

import dhlLogo from '../..//assets/logos/dhl.svg'
import fedExLogo from '../..//assets/logos/fedex.svg'
import upsLogo from '../..//assets/logos/ups.svg'
import uspsLogo from '../..//assets/logos/usps.svg'

export interface ServiceProviderLogoProps {
  /**
   * The provider to display. Must be a defined provider (`dhl`, `ups`, etc.)
   */
  provider: providerIDs
  /**
   * Optional additional classes to apply to the logo
   */
  className?: string
}

const providerLogos: { [key: string]: any } = {
  dhl: dhlLogo,
  ups: upsLogo,
  usps: uspsLogo,
  fedex: fedExLogo,
}

export default function ServiceProviderLogo({
  provider,
  className,
}: ServiceProviderLogoProps) {
  const { width, height } = serviceProviders[provider] || {}

  const widthToHeightRatio = Number(width) / Number(height)

  return (
    provider in serviceProviders && (
      <Image
        src={providerLogos[provider]}
        alt={`${provider} logo`}
        style={
          {
            '--ratio-width': width,
            '--ratio-height': height,
            width: `calc(var(--ratio-height)*${widthToHeightRatio}px)`,
          } as CSSProperties
        }
        className={clsx(
          '[aspect-ratio:var(--ratio-width)/var(--ratio-height)] h-6',
          className,
        )}
        width={width}
        height={height}
      />
    )
  )
}
